import { CollectionService } from './index';

const TraitThematicPackageService = CollectionService('thematic-packages-traits');

export default TraitThematicPackageService;
